
import React from 'react';
import {
	FormGroup,
	Input,
	FormControl,
	CustomText,
} from 'components';
import AfterPaySelector from "./afterPaySelector"

const AfterPay = ({shopContext }) => {
    return (
        <FormGroup 
            label="Split Payments" 
            info="Communicate split payments offers within the cart. (only activate this if you have a split payment provider active on shopify checkout)" fullWidth
        >
            <FormControl label="Customize" withSwitch={[shopContext, "settings.afterPay.isActive"]}>
                <CustomText
                    context={shopContext}
                    
                    path="settings.afterPay.text"
                    hasColor={true}
                    indicator="{{installments}}  {{split payment}}"
                    hasWeight="700"
                />
            </FormControl>
            <AfterPaySelector shopContext={shopContext}/>
            <FormControl label='Select split payment quantity'>
                <Input min={2} BindToContext={[shopContext, "settings.afterPay.splits"]}/>
            </FormControl>
        </FormGroup>
    )

}

export default AfterPay